import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) 15%",
    correct: false,
  },
  {
    option: "b) 45%",
    correct: false,
  },
  {
    option: "c) 85%",
    correct: true,
  },
  {
    option: "d) 100%",
    correct: false,
  },
  {
    option: "e) 0,5%",
    correct: false,
  },
];

export default function Question11(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question11: {
          title:
            "De acordo com o MIT, qual o potencial da IA generativa em detectar de ciberataques, em relação a análise manual?",
          option: option.option,
          correct: option.correct,
          order: 11
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "De acordo com o MIT, qual o potencial da IA generativa em detectar de ciberataques, em relação a análise manual?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
